import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';

const NAV = [
  { id: 'dashboard', icon: '◉', label: 'Dashboard', group: null },
  { id: 'projects',  icon: '⊞', label: 'Projects',  group: null },
  { id: 'schedule',  icon: '▤', label: 'Schedule / Gantt', group: 'Planning' },
  { id: 'costs',     icon: '💰', label: 'Cost Tracker',    group: 'Planning' },
  { id: 'incidents', icon: '⚠', label: 'Incident Log',    group: 'Field Logs' },
  { id: 'mrq',       icon: '📦', label: 'Material Requisition', group: 'Field Logs' },
  { id: 'vos',       icon: '△', label: 'Variation Orders', group: 'Field Logs' },
  { id: 'daily',     icon: '📋', label: 'Daily Reports',   group: 'Field Logs' },
  { id: 'ipcs',      icon: '💳', label: 'IPC – Subcontractors', group: 'Contracts' },
  { id: 'docs',      icon: '📄', label: 'Document Log',    group: 'Documentation' },
  { id: 'settings',  icon: '⚙', label: 'Settings / Export', group: 'System' },
];

export default function Sidebar({ page, setPage }) {
  const { user, logout } = useAuth();
  const { data, activeProject } = useData();

  const openIncidents = data.incidents.filter(i => i.status === 'Open' && i.projectId === activeProject?.id).length;
  const pendingMRQ = data.mrqs.filter(m => (m.status === 'Pending' || m.status === 'Draft') && m.projectId === activeProject?.id).length;

  let lastGroup = null;

  return (
    <nav className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-mark">⬡ ConstructPro</div>
        <div className="sidebar-logo-sub">Project Management Suite</div>
      </div>

      {activeProject && (
        <div className="sidebar-project" onClick={() => setPage('projects')} style={{ cursor: 'pointer' }}>
          <div className="sidebar-project-name">{activeProject.name}</div>
          <div className="sidebar-project-label">Active Project — click to switch</div>
        </div>
      )}

      <div style={{ marginTop: 8, flex: 1 }}>
        {NAV.map(item => {
          const groupChange = item.group !== lastGroup;
          lastGroup = item.group;
          const badge = item.id === 'incidents' && openIncidents > 0 ? openIncidents
                      : item.id === 'mrq' && pendingMRQ > 0 ? pendingMRQ
                      : null;
          return (
            <React.Fragment key={item.id}>
              {groupChange && item.group && (
                <div className="nav-group">{item.group}</div>
              )}
              <div className={`nav-item ${page === item.id ? 'active' : ''}`} onClick={() => setPage(item.id)}>
                <span className="nav-icon">{item.icon}</span>
                <span>{item.label}</span>
                {badge && <span className="nav-badge">{badge}</span>}
              </div>
            </React.Fragment>
          );
        })}
      </div>

      <div className="sidebar-user">
        <div className="user-avatar">{user?.avatar}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="user-name truncate">{user?.name}</div>
          <div className="user-role">{user?.title}</div>
        </div>
        <button className="icon-btn" title="Sign out" onClick={logout} style={{ fontSize: 14 }}>⏻</button>
      </div>
    </nav>
  );
}
